import {Controller} from "@hotwired/stimulus";

export default class GymMapController extends Controller {
  static values = {
    latitude: {type: Number, default: 19.425305},
    longitude: {type: Number, default: -99.194775},
  }

  static targets = ["map"]

  initialize() {
    this.initMap();
  }

  async initMap() {

    // The location of Uluru
    const position = {
      lat: this.latitudeValue,
      lng: this.longitudeValue,
    };

    console.debug(
      "Gym - Form, Init map",
      `lat=${this.latitudeValue}, lon=${this.longitudeValue}`
    );

    console.debug("Gym - Form, Init map", position);

    // Request needed libraries.
    //@ts-ignore
    const {Map} = await google.maps.importLibrary("maps");
    const {AdvancedMarkerElement} = await google.maps.importLibrary("marker");

    // The map, centered at Uluru
    const map = new Map(this.mapTarget, {
      zoom: 14,
      center: position,
      mapId: "DEMO_MAP_ID",
    });

    // The marker, positioned at Uluru
    const marker = new AdvancedMarkerElement({
      map: map,
      position: position,
      title: this.gymNameValue,
      gmpDraggable: true,
    });

    marker.addListener("dragend", (event) => {
      console.debug("=> Marker Dropped:", marker.position, event);

      this.latitudeInputTarget.value = marker.position.lat;
      this.longitudeInputTarget.value = marker.position.lng;
    });
  }
}
